<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.main
  width 100%
  height 100%
  margin-top 10px
  // border: 1px solid green;
  // background: url('../../../../../assets/img/trp/right.png') no-repeat;
  background-size 100% 100%
  .title
    height 30px
    font-size 16px
    font-family Microsoft YaHei
    font-weight bold
    color #fff
    line-height 30px
    // margin-left: 5px;
  .swiper-wrap
    margin-top 5px
    height 100px
    // overflow: hidden;
    // border: 1px solid green;
    width 100%
  .list-item
    background #0B2574
    height 46px
    line-height 46px
    display flex
    font-size 14px
    margin-bottom 5px
    color #FFF
    .item-rank
      width 10%
      color #fff
      text-align center
    .item1
      width 25%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item2
      width 20%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item3
      width 10%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .rackA
      color green
    .rackB
      color red
  .list-item1
    color #00FEFB
    height 40px
    font-size 16px
    display flex
    width 100%
    margin 0 auto
    background url('../../../../../assets/img/trp/table.png') no-repeat
    background-size 100% 100%
    .item1
      width 25%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item2
      width 20%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item3
      width 10%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
</style>

<template>
  <!-- <boxWrap :name="name" :min="true"> -->
  <!-- <div class="table"> -->

  <div class="main">
    <div class="title">高（剧）毒农药销售预警</div>
    <div class="list-item1">
      <div class="item1">销售时间</div>
      <div class="item1">经营主体</div>
      <div class="item2">农药名称</div>
      <div class="item2">登记证号</div>
      <div class="item3">实名情况</div>
    </div>
    <swiper :options="swiperOption"
            class="swiper-wrap"
            ref="mySwiper"
            v-if="tableData.length != 0">
      <swiper-slide v-for="(item, index) in tableData"
                    :key="index"
                    class="list-item">
        <div class="item1">{{ item.name }}</div>
        <div class="item1">{{ item.orderNumber }}</div>
        <div class="item2">{{ item.name1 }}</div>
        <div class="item2">{{ item.id }}</div>
        <div class="item3"
             :class="{rackA:item.number=='实名登记',
    rackB:item.number=='未登记'}">{{ item.number }}</div>
      </swiper-slide>
    </swiper>
  </div>
  <!-- </div> -->
  <!-- </boxWrap> -->
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['salesDataRealTime'],
  data () {
    return {
      name: '区域农业投入品流通销售排行榜',
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 100,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      },
      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
    }
  },
  methods:
  {
    changeColor (index) {
      if (index <= 3) {
        return `color:${this.colorList[index]}`;
      } else {
        return `color:${this.colorList[3]}`;
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted () {
    this.tableData = [{ name: '2018-08-03', orderNumber: '安吉盈元家庭农场', name1: '甲拌磷', id: 'PD85109-13', number: '实名登记' },
    { name: '2019-07-31', orderNumber: '安吉润发家庭农场有限公司', name1: '辛硫·甲拌磷', id: 'PD20100085', number: '未登记' }]
  }
}

</script>


// WEBPACK FOOTER //
// index.vue?7740de29